import React from "react"
import DataShop from "../../../data/shop"
import "./ShopActive.less"
import PieLegend from "../../../components/charts/pieLegend"
import BarHoriRatio from "../../../components/charts/barHoriRatio"

function formatList(list, total) {
  let res = []
  let other = 0
  list &&
    list.forEach((s, i) => {
      let r = Math.round((s.value / total) * 10000) / 100
      if (i > 10) {
        other += s.value
      } else {
        res.push({
          name: s.shop_name,
          value: r,
        })
      }
    })
  if (other) {
    res.push({
      name: "其他",
      value: Math.round((other / total) * 10000) / 100,
    })
  }
  return res
}

class ShopActive extends React.Component {
  constructor(props) {
    super(props)
    this.state = { from: [], after: [] }
  }

  componentDidMount() {
    this.getData()
  }

  getData() {
    let { id, date } = this.props
    DataShop.getShopActive(id, date).then(res => {
      let { from, total_from, after, total_to } = res.data || {}
      this.setState({
        after: formatList(after, total_to),
        from: formatList(from, total_from),
      })
    })
  }

  render() {
    let { from, after } = this.state
    return (
      <div className="shop-inner box-shop-active">
        <div className="inner-layout">
          <h2 className="shop-body-title">
            <i className="icon"> </i>
            <span className="i-title"> 顾客来自 </span>
          </h2>

          {from ? (
            <PieLegend list={from} color="#EA45CC" unit="%" title="顾客来自" />
          ) : null}
        </div>
        <div className="inner-layout">
          <h2 className="shop-body-title">
            <i className="icon"> </i>
            <span className="i-title"> 顾客去往 </span>
          </h2>
          {after ? (
            <BarHoriRatio list={after} color="#54D2E2" unit="%" />
          ) : null}
        </div>
      </div>
    )
  }
}

export default ShopActive
